import arionIcon from "@/assets/arion.svg";
import kvikaIcon from "@/assets/kvika.svg";
import indoIcon from "@/assets/indo.svg";
import isbIcon from "@/assets/isb.svg";
import lbiIcon from "@/assets/lbi.svg";
import bankIconDefault from "@/assets/bank.svg";

interface Props {
  bankId?: string;
  size?: number;
}

export function BankIcon({ bankId, size = 20 }: Props) {
  let iconSrc = bankIconDefault;
  if (bankId === "arion") iconSrc = arionIcon;
  else if (bankId === "kvika") iconSrc = kvikaIcon;
  else if (bankId === "isb") iconSrc = isbIcon;
  else if (bankId === "lbi") iconSrc = lbiIcon;
  else if (bankId === "indo") iconSrc = indoIcon;

  return (
    <span
      className="inline-flex items-center justify-center rounded bg-transparent dark:bg-transparent p-0"
      style={{ width: size, height: size }}
    >
      <img
        title={bankId}
        src={iconSrc}
        width={size - 4}
        height={size - 4}
        alt={bankId + " icon"}
        className="dark:invert"
      />
    </span>
  );
}
